import * as React from "react";
const TrapChild = React.forwardRef(
  ({ children }, ref) => /* @__PURE__ */ React.createElement("div", { ref }, children)
);
export {
  TrapChild
};
//# sourceMappingURL=TrapChild.js.map
